// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload-box {
  width: 100%;
  height: 100%;
  font-size: 16px;
  background-color: #c8dadf;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* File div */
}
.file-upload-box .box__dragndrop,
.file-upload-box .box__success,
.file-upload-box .box__error {
  display: none;
}
.file-upload-box .box__input {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.file-upload-box .box__file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.file-upload-box.has-advanced-upload {
  outline: 1px dashed #92b0b3;
  outline-offset: -8px;
}
.file-upload-box.has-advanced-upload .box__icon {
  color: #748c8e;
  display: block;
  margin-bottom: 30px;
  text-align: center;
}
.file-upload-box.has-advanced-upload .box__dragndrop {
  display: inline;
  font-weight: 400;
  text-align: center;
}
.file-upload-box.is-dragover {
  outline-color: #c8dadf;
  background-color: #fff;
}
.file-upload-box .box__button {
  font-weight: 700;
  color: #e5edf1;
  display: none;
  padding: 8px 16px;
  margin: 10px;
  border: 10px;
  box-sizing: border-box;
  font-family: "Yodiwo Fonts";
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  text-decoration: none;
  outline: none;
  position: relative;
  height: 42px;
  background-color: #00bcd4;
  text-align: center;
  border-radius: 4px;
}
.file-upload-box .box__button.choose__file {
  display: block;
  color: inherit;
  background-color: #eeeeee;
}
.file-upload-box .box__button.choose__file > label {
  cursor: pointer;
}
.file-upload-box .box__button.choose__file input[type='file'] {
  display: none;
}
.file-upload-box .box__button.choose__file:focus,
.file-upload-box .box__button.choose__file > label:focus {
  background-color: #eeeeee;
}
.file-upload-box .box__button.choose__file:hover,
.file-upload-box .box__button.choose__file > label:hover {
  background-color: #bdbdbd;
}
.file-upload-box .box__button:hover,
.file-upload-box .box__button:focus {
  background-color: #0f3c4b;
}
.file-upload-box .box__button.disabled {
  pointer-events: none;
  opacity: 0.3;
}
.file-upload-box.is-dropped .box__button {
  display: block;
}
.file-upload-box .box__file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.file-upload-box .box__file + label {
  max-width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
}
.file-upload-box .box__file + label:hover strong,
.file-upload-box .box__file:focus + label strong,
.file-upload-box .box__file.has-focus + label strong {
  color: #39bfd3;
}
.file-upload-box .box__file:focus + label,
.file-upload-box .box__file.has-focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}
.file-upload-box .box__restart {
  font-weight: 700;
}
.file-upload-box .box__restart:focus,
.file-upload-box .box__restart:hover {
  color: #39bfd3;
}
.file-upload-box .box__success,
.file-upload-box .box__error {
  display: none;
}
.file-upload-box.is-success .box__success {
  display: block;
  padding: 10px;
}
.file-upload-box.is-error .box__error {
  display: block;
  font-weight: 900;
  color: #f44336;
  padding: 10px;
}
.file-upload-box .box__progress {
  width: 80%;
}
.file-upload-box .box__progress input {
  display: none;
}
.file-upload-box .box__progress label {
  position: relative;
  display: block;
  width: 100%;
  height: 20px;
  background: transparent;
  border-radius: 4px;
  border: 2px solid white;
  overflow: hidden;
}
.file-upload-box .box__progress label div {
  position: absolute;
  top: 0;
  left: 0;
  background: #92b0b3;
  height: 100%;
  width: 0%;
}
.file-upload-box .box__progress span {
  display: inline-block;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
.file-upload-box .box__progress span:last-child {
  float: right;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
